import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { esParaTi, noEsParaTi } from '../data/oferta';
export function ParaQuienSection() {
  return <section aria-labelledby="para-quien-titulo" className="border-b border-violet-line/40 bg-violet-deep" data-id="element-52" data-mp="2emk6y597dfra">
      <div className="mx-auto max-w-5xl px-6 py-20 sm:py-24 lg:px-8" data-id="element-53" data-mp="24qh3mw2m7b2r">
        <h2 id="para-quien-titulo" className="font-serif text-3xl font-medium leading-tight text-bone sm:text-4xl" data-id="element-54" data-mp="24sjufibld88j">
          Este programa es para ti si...
        </h2>

        <div className="mt-10 grid gap-12 lg:grid-cols-[1.3fr_1fr] lg:gap-16" data-id="element-55" data-mp="2xh8ynq7y1toi">
          <ul className="space-y-5" data-id="element-56" data-mp="2jn883jr5bcz8">
            {esParaTi.map(item => <li key={item} className="flex gap-4" data-id="element-57" data-mp="2no9xl8v9gao0">
                <CheckIcon className="mt-1 h-5 w-5 flex-none text-gold" aria-hidden="true" data-id="element-58" data-mp="2nmyvddhgraz0" />
                <span className="font-sans text-base font-light leading-relaxed text-bone/85 sm:text-lg" data-id="element-59" data-mp="3g6nyjhbw8crb">
                  {item}
                </span>
              </li>)}
          </ul>

          <div className="border-l border-violet-line pl-6 lg:pl-10" data-id="element-60" data-mp="2w3b64rnb1i0g">
            <h3 className="font-sans text-[0.7rem] font-medium uppercase tracking-[0.24em] text-bone/50" data-id="element-61" data-mp="3aqwbytbkdvc2">
              No es para ti si
            </h3>
            <ul className="mt-5 space-y-4" data-id="element-62" data-mp="35z4st3uqmrvy">
              {noEsParaTi.map(item => <li key={item} className="flex gap-3" data-id="element-63" data-mp="3jq9knjrv6fvq">
                  <XIcon className="mt-0.5 h-4 w-4 flex-none text-bone/40" aria-hidden="true" data-id="element-64" data-mp="3fqiw7mpt8bud" />
                  <span className="font-sans text-sm font-light leading-relaxed text-bone/55" data-id="element-65" data-mp="3tp8w1a40kpmf">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}